import React, { Component } from "react";

import Popup from "../../layout/Popup";
import PortfolioCard from "./PortfolioCard";
import SectionHeader from "../../layout/SectionHeader";

import project1_img1_small from "../../layout/assets/keyposer-200-133.jpg";
import project1_img1_big from "../../layout/assets/keyposer-420-279.jpg";
import project1_img2_big from "../../layout/assets/keyposer_image2-420-280.jpg";

import project3_img1_small from "../../layout/assets/expensehive-200-133.jpg";
import project3_img1_big from "../../layout/assets/expensehive-420-280.jpg";
import project3_img2_big from "../../layout/assets/expensehive_image2-420-280.jpg";

import project4_img1_small from "../../layout/assets/simple_gratitudes-200-133.png";
import project4_img1_big from "../../layout/assets/simple_gratitudes-200-133.png";
import project4_img2_big from "../../layout/assets/simple_gratitudes-480-280.png";

import "./styles/Portfolio.css";

const colours = {
  project1: {
    primary: "rgba(252, 96, 35, 0.85)",
    secondary: "rgba(253, 129, 67, 0.85)"
  },
  project2: {
    primary: "rgba(38, 80, 114, .85)",
    secondary: "rgba(142, 207, 250, .85)"
  },
  project3: {
    primary: "rgba(249, 153, 30, .9)",
    secondary: "rgba(254, 238, 117, .9)"
  },
  project4: {
    primary: "rgba(173, 216, 230, 0.9)",
    secondary: "rgba(81, 143, 166, 0.9)"
  }
};

class Portfolio extends Component {
  state = {
    openPopup: false,
    popupImage1: project1_img1_big,
    popupAlt1: "Keyposer",
    popupImage2: project1_img1_small,
    popupAlt2: "Keyposer",
    colourPrimary: "",
    colourSecondary: "",
    popupHeaderText: "Keyposer",
    popupActionButtonText: "View Keyposer",
    link: "#",
    text:
      "Keyposer is a lightweight Chrome extension used to create music with text. Build a looping song with over 50 instrument sounds including Drums, Bass, Guitar and Piano."
  };

  handlePopup = project => {
    switch (project) {
      case "Keyposer":
        this.setState({
          openPopup: true,
          popupImage1: project1_img1_big,
          popupAlt1: "Keyposer",
          popupImage2: project1_img2_big,
          popupAlt2: "Keyposer on Chrome Web Store",
          colourPrimary: colours.project1.primary,
          colourSecondary: colours.project1.secondary,
          popupHeaderText: "Keyposer",
          popupActionButtonText: "View Keyposer",
          link:
            "https://chrome.google.com/webstore/detail/keyposer/iakdlnnobkapndjoemnnggjkoohablje",
          text:
            "Build a looping song with over 50 instrument sounds including Drums, Bass, Guitar and Piano. Upload new sounds to your own library and setup your own personal mixing board. Save your song as a .txt file and send it to others or just save it for later. Do all of this and more with Keyposer, a lightweight Chrome extension used to create music with text."
        });
        break;
      case "Simple Gratitudes":
        this.setState({
          openPopup: true,
          popupImage1: project4_img1_big,
          popupAlt1: "Simple Gratitudes",
          popupImage2: project4_img2_big,
          popupAlt2: "Simple Gratitudes",
          colourPrimary: colours.project4.primary,
          colourSecondary: colours.project4.secondary,
          popupHeaderText: "Simple Gratitudes",
          popupActionButtonText: "View Simple Gratitudes",
          link: "https://simplegratitudes.com",
          text:
            "Simple Gratitudes is a unique platform dedicated to fostering gratitude. Through our website, users can effortlessly save and share their moments of thankfulness. Our aim is to help individuals, from entrepreneurs to families, celebrate and document what they are grateful for."
        });
        break;
      case "ExpenseHive":
        this.setState({
          openPopup: true,
          popupImage1: project3_img1_big,
          popupAlt1: "ExpenseHive Beta",
          popupImage2: project3_img2_big,
          popupAlt2: "ExpenseHive Beta",
          colourPrimary: colours.project3.primary,
          colourSecondary: colours.project3.secondary,
          popupHeaderText: "ExpenseHive Beta",
          popupActionButtonText: "View ExpenseHive",
          link: "https://expensehive.com",
          text:
            "ExpenseHive was developed in order to make tracking small business expenses easier. With a simplified layout and organisation system, my hope was to make expenses more manageable. However, ExpenseHive is only in Beta stage of testing right now and many more features will be added before I move to full production scale. Future plans include a mobile application and easy access to receipt images."
        });
        break;
      default:
        return;
    }
  };

  handleClosePopup = () => {
    this.setState({
      openPopup: false
    });
  };

  render() {
    const {
      openPopup,
      popupImage1,
      popupAlt1,
      popupImage2,
      popupAlt2,
      colourPrimary,
      colourSecondary,
      popupHeaderText,
      popupActionButtonText,
      link,
      text
    } = this.state;

    return (
      <section className="section-portfolio" id="section-portfolio">
        <Popup
          openPopup={openPopup}
          closePopup={this.handleClosePopup}
          image1={popupImage1}
          altImage1={popupAlt1}
          image2={popupImage2}
          altImage2={popupAlt2}
          headerAlign="left"
          headerTitle={popupHeaderText}
          colourPrimary={colourPrimary}
          colourSecondary={colourSecondary}
          alignButton="left"
          buttonText={popupActionButtonText}
          link={link}
          text={text}
        />
        <SectionHeader
          headerAlign="center"
          colour="2"
          title="Portfolio"
          marginBottom="big"
        />

        <div className="row">
          <div className="col-1-of-3">
            <PortfolioCard
              colourPrimary={colours.project1.primary}
              colourSecondary={colours.project1.secondary}
              cardHeading="Keyposer"
              cardImage={project1_img1_big}
              cardImage2={project1_img1_small}
              cardDetails={[
                "Original Chrome Extension",
                "Pure JavaScript, HTML, CSS",
                "Fast and Lightweight",
                "Looping Audio Files",
                "Clean and DRY Codebase",
                "Minimal Library Use"
              ]}
              cardStack={["JavaScript", "HTML", "CSS"]}
              buttonText="About Keyposer"
              handlePopup={() => this.handlePopup("Keyposer")}
            />
          </div>
          <div className="col-1-of-3">
            <PortfolioCard
              colourPrimary={colours.project4.primary}
              colourSecondary={colours.project4.secondary}
              cardHeading="Simple Gratitudes"
              cardImage={project4_img1_big}
              cardImage2={project4_img1_small}
              cardDetails={[
                "Custom Library Components",
                "Supabase Functions",
                "Agile Development",
                "Prod, Stage, Dev Environments",
                "ReactJS and NodeJS",
                "Server-Side Rendering"
              ]}
              cardStack={["ReactJS", "NodeJS", "Supabase"]}
              buttonText="About Simple Gratitudes"
              handlePopup={() => this.handlePopup("Simple Gratitudes")}
            />
          </div>
          <div className="col-1-of-3">
            <PortfolioCard
              colourPrimary={colours.project3.primary}
              colourSecondary={colours.project3.secondary}
              cardHeading="ExpenseHive Beta"
              cardImage={project3_img1_big}
              cardImage2={project3_img1_small}
              cardDetails={[
                "Simplified Expense Tracking",
                "React and NodeJS",
                "Online and Offline data",
                "Lightweight application",
                "Easy to scale",
                "Built with Firestore"
              ]}
              cardStack={["React", "NodeJS", "Firestore"]}
              buttonText="About ExpenseHive"
              handlePopup={() => this.handlePopup("ExpenseHive")}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Portfolio/Portfolio.js